import { ISignUpApi } from "@api/auth.int";
import { Box, Button, Checkbox, FormControl, FormLabel, Input, Link, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, useBoolean } from "@chakra-ui/react";
import { useVVApi, useDeepAuth } from "components/api";
import { VizvButtonBack, VizvButtonCancel, VizvButtonPrimary, VizvCardHeader } from "components/vizvComponents";
import { useEffect, useState } from "react";
import { MdPersonAdd } from "react-icons/md";
import { DeepErrorBox, DeepErrorContainer } from "../../components/misc";
import { RemoteButton } from "../../components/RemoteButton";
import { getGReCaptcha } from "./DeepAuth";


export function SignUp({ onSignIn }: { onSignIn: (message: string) => void; }) {

	const api = useVVApi();
	const authCtx = useDeepAuth();

	const [isLoading, setIsLoading] = useBoolean();
	const [isGDPRAccepted, setIsGDPRAccepted] = useState(false);
	const [error, setError] = useState('');

	const usrSubmitSignUp = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		setError('');

		const target = e.target as typeof e.target & {
			userName: { value: string };
			email: { value: string };
			phoneNumber?: { value: string };
			password: { value: string };
			passwordAgain: { value: string };
		};
		const userName = target.userName.value;
		const email = target.email.value;
		const phoneNumber = target.phoneNumber?.value;
		const password = target.password.value;
		const passwordAgain = target.passwordAgain.value;
		if (password != passwordAgain) {
			setError('Nem stimmel a két jelszó!');
			return;
		}

		setIsLoading.on();
		try {
			const grecaptchaToken = await getGReCaptcha();
			const resp = await api.fetch<ISignUpApi>({
				url: '/auth/signup',
				method: 'POST',
				payload: {
					userName, email, password, grecaptchaToken, phoneNumber
				}
			});
			//authCtx.onSignIn(resp);
			onSignIn('Nézd meg az email-jeidet kérlek, küldtünk egy ellenőrző email-t!')
			//onClose();
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}

	return <form onSubmit={usrSubmitSignUp}>

		<ModalContent bg='cardbg.popup' className="popupart">
			<ModalHeader>
				<ModalCloseButton />
				<VizvCardHeader fontSize='xl' boxShadow='lg' mt={1} isModal>Regisztráció</VizvCardHeader>
			</ModalHeader>
			<ModalBody>
				<DeepErrorContainer error={error} isLoading={isLoading} onErrorClose={() => setError('')} >
				<fieldset disabled={isLoading}>
					<FormControl isRequired={true}>
						<FormLabel>Felhasználó név</FormLabel>
						<Input type='text' autoComplete="username" name='userName' />
					</FormControl>
					<FormControl isRequired={true}>
						<FormLabel>Email cím</FormLabel>
						<Input type='email' autoComplete="email webauthn" name='email' />
					</FormControl>
					<FormControl isRequired={false}>
						<FormLabel>Telefonszám</FormLabel>
						<Input type='tel' autoComplete="tel" name='phoneNumber' />
					</FormControl>
					<FormControl isRequired={true}>
						<FormLabel>Jelszó</FormLabel>
						<Input type='password' autoComplete="new-password webauthn" name='password' />
					</FormControl>
					<FormControl isRequired={true}>
						<FormLabel>Jelszó még egyszer</FormLabel>
						<Input type='password' autoComplete="new-password" name='passwordAgain' />
					</FormControl>
					<FormControl isRequired={true}>
						<FormLabel>Adatvédelmi szabály elfogadása</FormLabel>
						<Checkbox checked={isGDPRAccepted} onChange={e => setIsGDPRAccepted(e.currentTarget.checked)}>Elfogadom az <Link className="xx2" href="https://www.cka.hu/adatvedelmi-szabalyzat/" target='_blank'>Adatvédelmi szabályzatot</Link></Checkbox>
					</FormControl>
				</fieldset>
				<Box color='InactiveCaptionText' fontSize='sm' my={2}>
					This site is protected by reCAPTCHA and the Google
					<a href="https://policies.google.com/privacy">Privacy Policy</a> and
					<a href="https://policies.google.com/terms">Terms of Service</a> apply.
				</Box>
				</DeepErrorContainer>
			</ModalBody>

			<ModalFooter justifyContent='space-between'>
				<VizvButtonBack onClick={() => onSignIn('')}>Vissza</VizvButtonBack>
				<VizvButtonPrimary type='submit' isDisabled={!isGDPRAccepted} isLoading={isLoading} ml={3} protLev='any'
					leftIcon={<MdPersonAdd />}>
					Regisztrálok
				</VizvButtonPrimary>
			</ModalFooter>
		</ModalContent>
	</form>
}